function providerInvoiceSetExpirationDate(UserInfo, Alert, filtersUtils, DateUtils, ProviderInvoiceAPI) {
    return {
        restrict: 'AE',
        templateUrl: require('../../templates/provider-invoices-set-expiration-date.html'),
        controller: function ($scope, $rootScope, $filter) {
            /***********************************************************************************************************
            * Controller Attributes
            ***********************************************************************************************************/
            var $translate = $filter('translate');
            var self = this;

            /***********************************************************************************************************
            * Scope Attributes
            ***********************************************************************************************************/
            $scope.flagExpirationDateConfirm = false;
            $scope.listToUpdate = [];
            $scope.expiration_date = new Date;

            $scope.hasPerm = UserInfo.hasPerm('providers.change_set_provider_invoice_expiration_date');

            /***********************************************************************************************************
            * Scope Watchers
            ***********************************************************************************************************/
            $scope.$on("selectedItemsChange", function (e, selectedItemsChange) {
                $scope.listToUpdate = selectedItemsChange;
            });

            $scope.$on("selectedCounterChange", function (e, selectedCounterChange) {
                $scope.counter = selectedCounterChange;
            });

            /***********************************************************************************************************
            * Controller Methods
            ***********************************************************************************************************/
            function performRequest(ids) {
                var date = DateUtils.transformToRESTyDate($scope.expiration_date);
                var json = {ids: ids, expiration_date: date};

                ProviderInvoiceAPI.setExpirationDate(json).then(function (data) {
                    Alert.createAlert('success', $translate('PROVIDERS.PROVIDER_STATUS_UPDATED') + data.updated_expiration_date, true);
                    $rootScope.$broadcast('refreshList');
                }).catch(function (error) {
                    $scope.error_message = error.data.__all__[0];
                }).finally(function () {
                    $scope.flagExpirationDateConfirm = false;
                    $scope.listToUpdate = [];
                });
            }

            /***********************************************************************************************************
            * Scope Methods
            ***********************************************************************************************************/
            $scope.clickExpirationDateYes = function () {
                var ids = filtersUtils.getItemsToDownloadToInt($scope.listToUpdate);
                performRequest(ids);
            };

            $scope.confirmExpirationDate = function () {
                $scope.flagExpirationDateConfirm = true;
            };

            $scope.clickExpirationDateNo = function () {
                $scope.flagExpirationDateConfirm = false;
            };

        }
    }
}

export { providerInvoiceSetExpirationDate }
